import React from 'react';
import { cn } from '../../utils/cn';

export type LoadingSize = 'sm' | 'md' | 'lg';
export type LoadingLayout = 'inline' | 'section' | 'page';

const sizeClasses: Record<LoadingSize, string> = {
  sm: 'h-4 w-4',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
};

const layoutClasses: Record<LoadingLayout, string> = {
  inline: 'py-8',
  section: 'py-16',
  page: 'min-h-[50vh]',
};

interface SpinnerProps {
  size?: LoadingSize;
  className?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 'md', className }) => {
  return (
    <div
      className={cn(
        'inline-block animate-spin rounded-full border-b-2 border-blue-600',
        sizeClasses[size],
        className
      )}
      aria-hidden="true"
    />
  );
};

interface LoadingStateProps {
  message?: string;
  size?: LoadingSize;
  layout?: LoadingLayout;
  className?: string;
  fullScreen?: boolean;
  showMessage?: boolean;
}

const LoadingState: React.FC<LoadingStateProps> = ({
  message = 'Cargando...',
  size = 'md',
  layout = 'inline',
  className,
  fullScreen = false,
  showMessage = true,
}) => {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={message}
      className={cn(
        'flex flex-col items-center justify-center',
        fullScreen ? 'min-h-screen' : layoutClasses[layout],
        className
      )}
    >
      <Spinner size={size} />
      {showMessage && message ? (
        <p className="mt-4 text-sm text-gray-600">{message}</p>
      ) : null}
    </div>
  );
};

export default LoadingState;
